import * as React from 'react'

import { Skeleton } from '~/client/src/shared/components/shadcn-ui/skeleton'

export const WORKFLOW_CARD_SHELL_CLASS =
  'tw:mt-1.5 tw:min-w-60 tw:max-w-full tw:rounded-lg tw:border tw:border-solid tw:border-border tw:bg-background tw:p-3'

const WORKFLOW_CARD_MIN_HEIGHT = 'tw:min-h-[100px]'

export default function WorkflowCardPlaceholder() {
  return (
    <div
      aria-hidden="true"
      className={`${WORKFLOW_CARD_SHELL_CLASS} ${WORKFLOW_CARD_MIN_HEIGHT}`}
    >
      <Skeleton className="tw:h-3 tw:w-16" />
      <div className="tw:mt-2 tw:flex tw:items-center tw:gap-2">
        <Skeleton className="tw:size-4 tw:shrink-0" />
        <Skeleton className="tw:h-4 tw:w-2/3" />
      </div>
      <Skeleton className="tw:mt-3 tw:h-3 tw:w-1/3" />
    </div>
  )
}
